import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash-es'
import Status from '@constants/request_statuses.ts'
import { fetchTimelineCommentsById } from '../actions/ClientActions.js'

const initialState = {
  fetchTimelineCommentsById: {
    // '1': { status: 'idle', error: null },
  },
}

export const timelineCommentsSlice = createSlice({
  name: 'timeline_comments',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(fetchTimelineCommentsById.pending, (state, action) => {
        const { timelineId } = action.meta.arg
        state.fetchTimelineCommentsById[timelineId.toString()] = {
          status: Status.LOADING,
          error: null,
        }
      })
      .addCase(fetchTimelineCommentsById.fulfilled, (state, action) => {
        const { timelineId } = action.meta.arg
        state.fetchTimelineCommentsById[timelineId.toString()] = {
          status: Status.SUCCEEDED,
          error: null,
        }
      })
      .addCase(fetchTimelineCommentsById.rejected, (state, action) => {
        const { timelineId } = action.meta.arg
        state.fetchTimelineCommentsById[timelineId.toString()] = {
          status: Status.FAILED,
          error: action.payload,
        }
      })
  },
})

// seelctors
const selectBase = (state, props) => {
  return state.timelineComments
}
export const selectLoadTimelineCommentsByIdStatus = (state, props) => {
  const { timelineId } = props
  const timelineIdString = timelineId.toString()
  return get(selectBase(state, props), ['fetchTimelineCommentsById', timelineIdString, 'status'])
}

export const selectLoadTimelineCommentsByIdError = (state, props) => {
  const { timelineId } = props
  const timelineIdString = timelineId.toString()
  return get(selectBase(state, props), ['fetchTimelineCommentsById', timelineIdString, 'error'])
}

export const actions = {
  ...timelineCommentsSlice.actions,
}

export default timelineCommentsSlice.reducer
